import { AccountFeatures } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { Button, Col, Modal, Row } from "react-bootstrap"
import { FormattedMessage, injectIntl } from "react-intl"
import Icon from "../../common/icon/icon.component"
import CreditLimitProtectionButton from "../CreditLimitProtectionButton"

type OwnProps = {
    onClose :  () => void,
    sendBySMS : () => void,
    sendByEmail : () => void
    printPdf : () => void
}

const SendAsModal = (props : OwnProps) => {
    return (
        <Modal show={true} centered={true} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FormattedMessage
                        id="invoice.send_as.title"
                        defaultMessage="Send or Print the invoice"
                    />                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="mb-4">
                    <Col className="d-flex justify-content-center align-items-center">
                        <CreditLimitProtectionButton
                            creditLimit={0}
                            buttonClassName={"btn btn-primary"}
                            onClickEventCallback={props.sendBySMS}
                            buttonIcon={<Icon value={"mobile-alt"} className={"mr-1"} />}
                            buttonLabel={<FormattedMessage
                                id="invoice.edit.issue_and_send_sms_btn"
                                defaultMessage="SMS"
                            />}
                            isDisabled={false}
                            protectedFeatures={[AccountFeatures.FeatureSms]}>
                        </CreditLimitProtectionButton>
                    </Col>
                </Row >
                <Row className="mb-4">
                    <Col className="d-flex justify-content-center align-items-center">
                        <Button className="btn btn-primary" onClick={props.sendByEmail}>
                            <Icon value={"envelope"} className={"mr-1"} />
                            <FormattedMessage
                                id="invoice.send_as.send_by_email"
                                defaultMessage="Send by Email"
                            />
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col className="d-flex justify-content-center align-items-center">
                        <button className="btn btn-outline-primary" onClick={props.printPdf}>
                            <Icon value={"print"} className={"mr-1"} />
                            <FormattedMessage id="quote.analytics.print_btn"/>
                        </button>
                    </Col>
                </Row>
            </Modal.Body>
        </Modal>
    )
}

export default injectIntl(SendAsModal)



// WEBPACK FOOTER //
// ./src/invoice/components/SendAsModal.tsx